import { SourceCodeRepository } from '@/domain/repositories/sourceCode/sourceCodeRepository'

export class GetSourceCodeByJudgeIdUseCase {
  constructor(private repository: SourceCodeRepository) {}

  async getSourceCodeByJudgeId(judgeId: number): Promise<string> {
    try {
      return await this.repository.getSourceCodeByJudgeId(judgeId)
    } catch (error) {
      console.error(`Error in GetSourceCodeByJudgeId: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
